<script setup lang="ts">
import { eventBus } from "#bb/lib/eventBus";

const props = defineProps<{ id: string }>();

const { getContentById } = useContentManager();
const definitionData = computed(() => getContentById(props.id));

const features = inject("render-features", { editor: false });

const commands = [
  {
    id: "editors-group",
    type: "group",
    name: "Editors",
    description: "Table of Contents editors",
    commands: [
      {
        id: "edit",
        name: "Edit",
        description: "Edit this table of contents",
        action: async () => {
          eventBus.emit(`component:onEdit:${props.id}`, {
            data: definitionData.value,
          });
        },
        icon: "lucide:edit",
      },
    ],
  },
];

defineExpose({
  commands,
  properties: {
    id: props.id,
    name: "Table of Contents",
    icon: "lucide:list-tree",
  },
});
</script>

<template>
  <div
    v-if="features.editor"
    class="inline-flex items-center gap-2 rounded-sm border border-dashed bg-muted/30 px-3 py-2 text-xs text-muted-foreground"
  >
    <Icon mode="svg" size="14" name="lucide:list-tree" />
    Table of Contents (rendered in PDF export)
  </div>

  <div v-if="features.editor" class="hidden">
    <editor-reports-table-of-contents :id="props.id" />
  </div>
</template>

<script lang="ts">
import { ComponentDefinitionIds } from "#bb/lib/componentDefinitionIds";

export default {
  componentId: ComponentDefinitionIds.TABLE_OF_CONTENTS,
  icon: "lucide:list-tree",
  editor: () => import("#bb/components/editor/reports/table-of-contents.vue"),
  type: "Table of Contents",
  description: "Defines the PDF report table of contents rendered by the export compiler.",
  default: {
    title: "Table of contents",
  },
  categories: ["Reports"],
  order: 12011,
};
</script>
